import { render, staticRenderFns } from "./consultTip.vue?vue&type=template&id=391379e3&scoped=true"
import script from "./consultTip.vue?vue&type=script&lang=js"
export * from "./consultTip.vue?vue&type=script&lang=js"
import style0 from "./consultTip.vue?vue&type=style&index=0&id=391379e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391379e3",
  null
  
)

export default component.exports